import { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';

import PortalSidebar from './PortalSidebar';
import TopBar from './TopBar';
import DevUserSwitcher from './DevUserSwitcher';
import '../../styles/design-tokens.css';

const PORTAL_ROUTE_TITLES = [
  ['/portal/tickets/',      'Ticket Detail — Customer Portal'],
  ['/portal/tickets',       'My Tickets — Customer Portal'],
  ['/portal/dispatch',      'My Shipments — Customer Portal'],
  ['/portal/inventory',     'On-Site Inventory — Customer Portal'],
  ['/portal/fulfillment',   'Self Fulfillment — Customer Portal'],
  ['/portal/locations',     'Stock Locations — Customer Portal'],
  ['/portal',               'Portal — Customer Portal'],
];

const SIDEBAR_WIDTH = 260;
const SIDEBAR_COLLAPSED = 72;

export default function PortalShell() {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const match = PORTAL_ROUTE_TITLES.find(([prefix]) => location.pathname.startsWith(prefix));
    document.title = match ? match[1] : 'Customer Portal';
  }, [location.pathname]);

  const sidebarWidth = collapsed ? SIDEBAR_COLLAPSED : SIDEBAR_WIDTH;

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', backgroundColor: '#ffffff' }}>
      <PortalSidebar collapsed={collapsed} />

      <Box
        component="main"
        sx={{ flex: 1,
          display: 'flex',
          flexDirection: 'column',
          marginLeft: `${sidebarWidth}px`,
          minHeight: '100vh',
          backgroundColor: 'transparent',
          transition: 'margin-left 0.2s ease',
        }}
      >
        <TopBar collapsed={collapsed} onToggle={() => setCollapsed((prev) => !prev)} />

        <Box
          sx={{ flex: 1,
            mt: '88px',
            borderTopLeftRadius: '16px',
            borderTopRightRadius: '16px',
            borderBottomLeftRadius: '16px',
            borderBottomRightRadius: '16px',
            backgroundColor: 'var(--background)',
            overflowY: 'auto',
            overflowX: 'hidden',
            pt: 3,
            px: 0,
            pb: 3,
          }}
        >
          <Outlet />
        </Box>
      </Box>

      <DevUserSwitcher />
    </Box>
  );
}
